/**
 * Resolve an org-relative href (e.g. "/settings/integrations") to a full
 * path by prepending the current organization prefix from the URL.
 */
export function resolveHref(href: string): string {
  // Pass through absolute URLs and non-path schemes (mailto:, https:, etc.)
  if (/^[a-z][a-z0-9+.-]*:/i.test(href)) return href;

  const match = window.location.pathname.match(/^\/([^/]+)/);
  return match ? `/${match[1]}${href}` : href;
}
